<li
  class="onboarding-step"
  (click)="stepSelect.emit(step())"
  [ngClass]="{
    'is-complete': step().state === 'done',
    'is-current': step().state === 'in-progress',
    'is-upcoming': step().state === 'pending',
    'is-under-review': step().state === 'under-review',
    'is-actionable': step().isActionable,
  }"
  [attr.tabindex]="step().isActionable ? 0 : -1"
  [attr.role]="step().isActionable ? 'button' : null">
  <span class="step-marker">
    <span class="step-marker__content" aria-hidden="true">
      @if (step().state === 'done') {
        <span class="icon-done text-success-s2"></span>
      } @else if (index() !== null) {
        {{ index()! + 1 }}
      }
    </span>
  </span>

  <div class="step-content">
    <div class="step-header">
      <span class="step-title" [ngClass]="{ 'is-link': step().isActionable }">
        {{ step().title }}
      </span>
      @if (step().status || step().isActionable) {
        <span class="step-meta">
          @if (step().status) {
            <span
              class="status-pill"
              [ngClass]="{
                'is-done': step().state === 'done',
                'is-todo': step().state === 'in-progress',
                'is-under-review': step().state === 'under-review',
              }">
              {{ step().status }}
            </span>
          }
          @if (step().isActionable) {
            <span class="fas fa-chevron-right" aria-hidden="true"></span>
          }
        </span>
      }
    </div>
    @if (step().state !== 'done' && step().description) {
      <p class="step-description" [innerHTML]="step().description"></p>
    }
  </div>
</li>
